import MicrophoneIcon from '@ui-components-3/icons/lib/solid/Microphone'

const AudioVisualizer = ({ audioLevel }) => {
  return (
    <div className="flex w-full gap-3">
      <MicrophoneIcon className="w-5 h-5 text-neutral-700" aria-hidden="true" />
      <div className="w-full h-5 bg-primary-200 rounded-3xl">
        <div className="h-5 rounded-3xl bg-primary-700" style={{ width: `${audioLevel}0%` }} />
      </div>
    </div>
  )
}

export default AudioVisualizer
